import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { Quote, BadgeCheck } from "lucide-react";

export default function Testimonials() {
  const testimonials = useContent().testimonials;
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="eyebrow mb-4">{testimonials.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{testimonials.title}</h2>
          <p className="mt-4 text-[#5c6577] text-lg">{testimonials.text}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-14">
          {testimonials.items.map((t) => (
            <div key={t.name} className="card-lift rounded-2xl border border-[#efe9dd] bg-[#faf8f4] p-8">
              <Quote size={28} className="text-[#e0cba5]" />
              <p className="mt-4 text-[#3a4258] text-lg leading-relaxed font-serif-lux italic">“{t.quote}”</p>
              <div className="mt-6 flex items-center justify-between border-t border-[#f0ece3] pt-5">
                <div>
                  <div className="font-medium text-[#16233d]">{t.name}</div>
                  <div className="text-sm text-[#8a8f9c]">{t.country}</div>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-[#8f6f3f]">
                  <BadgeCheck size={16} className="text-[#b08d57]" /> {testimonials.customerSince} {t.since}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
